import "./CompareGrid.scss";

import React from "react";

import { CompareGridItem } from "../../models/app-data-model";
import CompareGridRow from "../compare-grid-row/CompareGridRow";
import { Grid2 } from "@mui/material";

export type CompareGridProps = {
  grid: CompareGridItem[];
};

const CompareGrid: React.FC<CompareGridProps> = ({ grid }) => {
  const rows = grid.map((gridItem, index) => <CompareGridRow row={ gridItem.row} key={ index} />)
  return <Grid2 container size={12} className='compare-grid'>
    {rows}
  </Grid2>;
};

export default CompareGrid;
